import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useGeneralReportPdfExportsStore = defineStore('generalReportPdfExports', {
  state,
  getters,
  actions
})

export default useGeneralReportPdfExportsStore
